import LoadingState from '@/api/LoadingState';

const state = {
  loadingState: LoadingState.INITIAL,
  all: [],
}

export default state
